import { render, staticRenderFns } from "./StlViewerPage.vue?vue&type=template&id=35e3343e&scoped=true"
import script from "./StlViewerPage.vue?vue&type=script&lang=js"
export * from "./StlViewerPage.vue?vue&type=script&lang=js"
import style0 from "./StlViewerPage.vue?vue&type=style&index=0&id=35e3343e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e3343e",
  null
  
)

export default component.exports